import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import Header from "../../components/Header";
import CompaniesService from "../../services/company.service";

export default function ChooseCompany() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { user, setUser } = useAuth();
  const { setLoading } = useLoading();
  const [companys, setCompanys] = useState([]);

  const handleClick = ({ Com_Code, Com_Name, Com_Logo, ReportHead_TH }) => {
    setUser({ ...user, Com_Code, Com_Name, Com_Logo, ReportHead_TH });
    navigate("/");
  };

  useEffect(() => {
    setLoading(true);
    CompaniesService.getAllCompanies()
      .then((response) =>
        setCompanys(
          user.company
            ? response.filter((item) => item.Com_Code === user.company)
            : response
        )
      )
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>เลือกบริษัท</title>
        <meta name="description" content="Choose Company Page" />
      </Helmet>

      <Header />

      <div className="vw-100 vh-100 d-flex flex-column justify-content-center align-items-center">
        <Container className="chooseCompany">
          <Card className="bg-transparent border-0">
            <Card.Header className="w-100 pb-0 text-center bg-transparent border-bottom-0">
              <Card.Title className="fs-2">เลือกบริษัท</Card.Title>
            </Card.Header>

            <Card.Body className="p-0">
              <Row xs={2} className="mt-1 justify-content-center">
                {companys.map(
                  (company) =>
                    company.Com_Code !== "0000" && (
                      <Col
                        key={company.Com_Code}
                        className="m-1 m-md-2 m-xl-3 px-0 text-center"
                      >
                        <Button
                          variant="light"
                          className="w-100 h-100 rounded-4 bg-white shadow-sm"
                          onClick={() => handleClick(company)}
                        >
                          {company.Com_Logo && (
                            <Card.Img
                              className="h-100"
                              src={`${process.env.REACT_APP_STORAGE_URL}/company-logo/${company.Com_Logo}`}
                              alt={company.Com_Name}
                            />
                          )}
                        </Button>

                        {user.company && (
                          <Card.Title className="mt-4 fs-2 text-truncate">
                            {company.Com_Name}
                          </Card.Title>
                        )}
                      </Col>
                    )
                )}
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
}
